import {createSlice, type PayloadAction} from "@reduxjs/toolkit";

import type {RootState} from "@/store/types/RootState";

import {PropertyGalleryTab} from "../types/PropertyGalleryTab";

interface IPropertyGalleryModalState {
    initialTab: PropertyGalleryTab | null;
    isOpen: boolean;
}

const INITIAL_STATE: IPropertyGalleryModalState = {
    initialTab: null,
    isOpen: false
};

export const propertyGalleryModalSlice = createSlice({
    initialState: INITIAL_STATE,
    name: "propertyGalleryModal",
    reducers: {
        closePropertyGalleryModal: () => INITIAL_STATE,
        openPropertyGalleryModal: (_state, action: PayloadAction<PropertyGalleryTab>) => ({
            initialTab: action.payload,
            isOpen: true
        })
    }
});

export const selectPropertyGalleryModal = (state: RootState) => state.propertyGalleryModal;
export const {closePropertyGalleryModal, openPropertyGalleryModal} = propertyGalleryModalSlice.actions;
import {createSlice, type PayloadAction} from "@reduxjs/toolkit";

import type {RootState} from "@/store/types/RootState";

import {PropertyGalleryTab} from "../types/PropertyGalleryTab";

interface IPropertyGalleryModalState {
    initialTab: PropertyGalleryTab | null;
    isOpen: boolean;
}

const INITIAL_STATE: IPropertyGalleryModalState = {
    initialTab: null,
    isOpen: false
};

export const propertyGalleryModalSlice = createSlice({
    initialState: INITIAL_STATE,
    name: "propertyGalleryModal",
    reducers: {
        closePropertyGalleryModal: () => INITIAL_STATE,
        openPropertyGalleryModal: (_state, action: PayloadAction<PropertyGalleryTab>) => ({
            initialTab: action.payload,
            isOpen: true
        })
    }
});

export const selectPropertyGalleryModal = (state: RootState) => state.propertyGalleryModal;
export const {closePropertyGalleryModal, openPropertyGalleryModal} = propertyGalleryModalSlice.actions;
